import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';
import { GridService } from 'src/app/shared/services/grid.service';


@Component({
  selector: 'app-account-multi-list',
  templateUrl: './../../../templates/forms/modals/budget-transfer-entry.component.html',
})
export class BudgetTransferEntryComponent implements OnInit {

  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "BudgetTransferEntryGrid"

  budgetList: any[] = [];
  searchFields: any[] = ['FROM_ACC_NAME', 'FROM_BU_NAME'];
  public searchString;

  constructor(public langService: LangService,
    private dataService: CommonService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.year, field: 'YEAR', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.fromAccount, field: 'FROM_ACC_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.fromDepartment, field: 'FROM_BU_NAME', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.transferDate, field: 'TRANSFER_DATE', sortable: true, resizable: true, hide: false },
    ];
  }


  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.dataService.getBudgetTransNo()
      .subscribe(arg => { this.budgetList = arg.body });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }
}
